function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.39856 31.6321C0.39856 33.4425 1.78583 34.8506 3.56945 34.8506H26.8227C28.5403 34.8506 29.9936 33.4425 29.9936 31.6321V13.3942H0.39856V31.6321ZM4.62642 18.7583C4.62642 18.2219 5.08884 17.6855 5.68338 17.6855H12.0252C12.5537 17.6855 13.0821 18.2219 13.0821 18.7583V25.1952C13.0821 25.7987 12.5537 26.2681 12.0252 26.2681H5.68338C5.08884 26.2681 4.62642 25.7987 4.62642 25.1952V18.7583ZM26.8227 4.81166H23.6518V1.59321C23.6518 1.0568 23.1233 0.520386 22.5948 0.520386H20.4809C19.8864 0.520386 19.4239 1.0568 19.4239 1.59321V4.81166H10.9682V1.59321C10.9682 1.0568 10.4397 0.520386 9.91124 0.520386H7.79731C7.20277 0.520386 6.74035 1.0568 6.74035 1.59321V4.81166H3.56945C1.78583 4.81166 0.39856 6.28679 0.39856 8.03012V11.2486H29.9936V8.03012C29.9936 6.28679 28.5403 4.81166 26.8227 4.81166Z",
  fill: "#1D2A30"
});

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.e7712683.svg";
export { ForwardRef as ReactComponent };